// extracted by mini-css-extract-plugin
export default {"quote":"InlineQuote_quote__SPR-P"};